import * as releaseToggleClientApi from "../ReleaseToggles/ReleaseToggleApiClient";
import {LaunchDarklyReleaseToggleType, ReleaseTogglesType} from "../ReleaseToggles/ReleaseToggles";

export const getLDReleaseTogglesPromises = () => {
    const launchDarklyFlags: LaunchDarklyReleaseToggleType = {
        enableEstateFlowchart: undefined,
        enableEnhancedLifestyleFunding: undefined,
        enableEstateFlowchartMVPRelease: undefined,
        enableWildCardInEstateFlowchart: undefined,
        enableGoogleAnalytics: undefined,
        enableHandlePresenterLeaveActiveMeeting: undefined,
        enableDEFGoogleAnalytics: undefined,
        enableAgendaGoogleAnalytics: undefined,
        enableGoalsGoogleAnalytics: undefined,
        enablePlanSummaryGoogleAnalytics: undefined,
        enableAssetTitlingGoogleAnalytics: undefined,
        enableAssetsGoogleAnalytics: undefined,
        enableWPOptimizerGoogleAnalytics: undefined,
        enableComparePlansGoogleAnalytics: undefined,
        enable2026SunsetExemption: undefined,
        enableOneIntegration: undefined,
        enableEstateTaxGraduatedRates: undefined,
        enableAdditionalDistributionLayer: undefined,
        enableStandardizedClientPersonas: undefined,

    };

    return Object.keys(launchDarklyFlags).map((flagName) =>
        releaseToggleClientApi.getLaunchDarklyFlag(flagName)
            .then((flagValue) => ({
                flagName,
                flagValue,
            }))
            .catch((error) => {
                console.error(`Failed to retrieve ${flagName}`, error.message);
                return {flagName, flagValue: undefined};
            })
    );
};

export const fetchAndSetReleaseToggles = async (): Promise<ReleaseTogglesType> => {
    try {
        const [releaseTogglesFromGpiConfig, ...ldReleaseToggles] = await Promise.all([
            releaseToggleClientApi.getReleaseToggles(),
            ...getLDReleaseTogglesPromises()
        ]);

        const releaseTogglesFromLaunchDarkly: ReleaseTogglesType = ldReleaseToggles
            .reduce((accumulator, {flagName, flagValue}) => {
                accumulator[flagName] = flagValue;
                return accumulator;
            }, {} as Record<string, any>);
        return {...releaseTogglesFromGpiConfig, ...releaseTogglesFromLaunchDarkly}

    } catch (error) {
        console.error(error);
        return {};
    }
};